import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EscalatorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"escalator"}/>
}
